import { TextField, TextFieldProps } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { $WhiteSmoke, $primaryColor } from '@Styles/colors'

const useStylesReddit = makeStyles((theme) => ({
    root: {
        border: '1px solid #E4E9ED',
        overflow: 'hidden',
        borderRadius: 10,
        backgroundColor: '#fff',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // height: '50px',
        '&:hover': {
            backgroundColor: '#fff',
        },
        '& .Mui-disabled': {
            '&:hover': {
                cursor: 'no-drop',
            },
            background: $WhiteSmoke,
            // backgroundColor: '#E0E0E0',
        },
        '&$focused': {
            backgroundColor: '#fff',
            // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            boxShadow: 'none',
            borderColor: $primaryColor,
            outline: 'none',
        },
        '& .MuiFormControl-root': {
            background: 'red',
        },
        '& .MuiFilledInput-input': {
            padding: '21px 12px 6px',
            fontWeight: 'bold',
            fontSize: 16,
        },
    },
    focused: {},
}))

const useStylesLabel = makeStyles((theme) => ({
    root: {
        fontSize: '14px',
        color: '#757575',
        margin: '0',
        '&$focused': {
            color: '#757575',
        },
    },
    focused: {},
}))
const useStyleFormControl = makeStyles((theme) => ({
    root: {
        height: '100%',
    },
}))

interface IAdornment {
    startAdornment?: any
}

type RedditTextFieldTypes = IAdornment & TextFieldProps

export function RedditTextField({
    startAdornment,
    ...props
}: RedditTextFieldTypes) {
    const classes = useStylesReddit()
    const labelClasses = useStylesLabel()

    return (
        <TextField
            InputProps={{ classes, disableUnderline: true, startAdornment }}
            InputLabelProps={{ classes: labelClasses }}
            // FormControlProps={{ classes: FormControlClasses }}
            {...props}
        />
    )
}
